import React, { useEffect } from "react";
import InputBase from "@mui/material/InputBase";
import { useResponsive } from "../../../../hooks/useResponsive";
import SearchIcon from "../../../../styles/svg/newSearchIcon.svg";

function SearchBoard({ onSearch, searchQuery }) {
  const isMobile = useResponsive("down", "md");
  const inputRef = React.useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [searchQuery]);

  function handleChange(event) {
    event.stopPropagation();
    event.preventDefault();
    onSearch(event.target.value);
  }

  return (
    <div className="search-container">
      <div className="search-icon-wrapper">
        <img src={SearchIcon} alt="search" style={{ zIndex: "1" }} />
      </div>
      <InputBase
        className={`search-input ${isMobile ? "mobile" : ""}`}
        placeholder="Search…"
        inputProps={{ "aria-label": "search" }}
        value={searchQuery}
        onChange={handleChange}
        onKeyDown={(event) => event.stopPropagation()}
        type="search"
        inputRef={inputRef}
      />
    </div>
  );
}

export default SearchBoard;
